import { LocalizedElement, sourceAttribute } from "../i18n/LocalizedCopy";
import { formattingLocale } from "../i18n/formattingLocale";
import { LocalizedText, useSourceLanguage } from "../i18n/LocalizedCopy";
import React from "react";
import { Link } from "react-router-dom";
import "./TrustProfile.css";

const DELAYS = {
  less_than_hour: "moins d’une heure",
  few_hours: "quelques heures",
  less_than_day: "moins de 24 heures",
  one_to_two_days: "un à deux jours",
  two_to_three_days: "deux à trois jours",
  more_than_three_days: "plus de trois jours",
};

export function responseDelayLabel(value) {
  return DELAYS[value] || "";
}

export default function TrustCompactSummary({ "data-et-copy": __etCopy = "", summary, compact = false, title = "Profil de confiance" }) {
  useSourceLanguage();
  if (!summary) return null;
  const indicators = Array.isArray(summary.indicators) ? summary.indicators.slice(0, compact ? 3 : 6) : [];
  const badges = Array.isArray(summary.badges) ? summary.badges.slice(0, compact ? 2 : 6) : [];
  const hasFacts = indicators.length || summary.response || summary.reviews || badges.length || summary.passport;
  if (!hasFacts) return null;

  return (
    <section className={`trust-compact${compact ? " is-compact" : ""}`} aria-label={title}>
      <div className="trust-compact__heading">
        <div><span aria-hidden="true">◇</span><strong>{<LocalizedText source={title} marked={__etCopy.split(',').includes("title") || title === "Profil de confiance"} />}</strong></div>
        {!compact ? <Link to="/confiance"><LocalizedText source={"Comprendre"} /></Link> : null}
      </div>
      {indicators.length ? (
        <ul className="trust-compact__facts">
          {indicators.map((item) => <li key={item.key}><span aria-hidden="true">✓</span>{item.label}</li>)}
        </ul>
      ) : null}
      {summary.response ? (
        <p className="trust-compact__metric"><LocalizedText source={"Répond à environ "} /><strong>{summary.response.rate} %</strong><LocalizedText source={" des contacts admissibles"} />{responseDelayLabel(summary.response.delay_bucket) ? <LocalizedText source={` · délai habituel : ${responseDelayLabel(summary.response.delay_bucket)}`} pattern={"· délai habituel : __ET_VALUE_0__"} /> : ""}.
        </p>
      ) : null}
      {summary.reviews ? (
        <p className="trust-compact__metric">
          <strong>{Number(summary.reviews.average).toLocaleString(formattingLocale(), { maximumFractionDigits: 1 })} / 5</strong>
          {` · ${summary.reviews.count} avis ${summary.reviews.count > 1 ? "admissibles" : "admissible"}`}
        </p>
      ) : null}
      {badges.length ? (
        <LocalizedElement elementType={"div"} copyAttributes={["aria-label"]} className="trust-compact__badges" aria-label={sourceAttribute("Badges de confiance actifs")}>
          {badges.map((badge) => <span key={`${badge.key}-${badge.context}`} title={badge.description}>{badge.icon} {badge.label}</span>)}
        </LocalizedElement>
      ) : null}
      {summary.passport?.status === "obtained" ? (
        <div className="trust-compact__passport">
          <span aria-hidden="true">◇</span>
          <div>
            <strong>{summary.passport.label}</strong>
            <small><LocalizedText source={"Critères serveur "} />{summary.passport.rules_version}<LocalizedText source={". Ce Passeport ne garantit jamais l’absence de risque."} /></small>
          </div>
        </div>
      ) : null}
      {!compact ? <p className="trust-compact__disclaimer">{summary.disclaimer}</p> : null}
    </section>
  );
}
